import { useState, useEffect } from 'react';

/**
 * Hook para gestionar la paginación backend
 * @param {Object} dateRange - Rango de fechas
 * @param {string|null} selectedSupervisor - Supervisor seleccionado
 * @param {Array} selectedAgents - Agentes seleccionados
 * @returns {Object} { currentPageIndex, pageKeys, hasMorePages, setCurrentPageIndex, resetPagination, updatePaginationKeys }
 */
export function usePagination(dateRange, selectedSupervisor, selectedAgents) {
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [pageKeys, setPageKeys] = useState([]);
  const [hasMorePages, setHasMorePages] = useState(false);

  // Auto-reset paginación cuando cambia el rango de fechas
  useEffect(() => {
    if (dateRange?.startDate && dateRange?.endDate) {
      // Reset paginación
      setCurrentPageIndex(1);
      setPageKeys([]);
      setHasMorePages(false);
      
      console.log('Rango de fechas cambiado, reseteando paginación');
    }
  }, [dateRange]); // Solo fecha, NO incluir supervisor/agentes aquí

  // Resetear paginación cuando cambian los filtros (supervisor/agentes)
  useEffect(() => {
    if (dateRange?.startDate && dateRange?.endDate) {
      setCurrentPageIndex(1);
      setPageKeys([]);
      setHasMorePages(false);
      
      console.log('Filtros cambiados (supervisor/agentes), reseteando paginación');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSupervisor, selectedAgents]); // Solo filtros, NO incluir dateRange

  const resetPagination = () => {
    setCurrentPageIndex(1);
    setPageKeys([]);
    setHasMorePages(false);
  };

  const updatePaginationKeys = (pageIndex, startKey, timestampFrom) => {
    if (!startKey || !timestampFrom) return;
    
    setPageKeys(prev => {
      const newKeys = [...prev];
      newKeys[pageIndex - 1] = {
        startKey,
        timestampFrom
      };
      console.log('pageKeys actualizado:', newKeys);
      return newKeys;
    });
  };

  return {
    currentPageIndex,
    pageKeys,
    hasMorePages,
    setCurrentPageIndex,
    setHasMorePages,
    resetPagination,
    updatePaginationKeys
  };
}

